import { render, staticRenderFns } from "./PrivacyContent.vue?vue&type=template&id=8815abf4&scoped=true"
import script from "./PrivacyContent.vue?vue&type=script&lang=ts"
export * from "./PrivacyContent.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyContent.vue?vue&type=style&index=0&id=8815abf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8815abf4",
  null
  
)

export default component.exports